import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RevokedBadgeModel } from '../achievements.model';

/**
 * Plain (no confetti) notice for badges an admin revoked since the last check, with the admin's
 * reason when one was given. Opened by the celebration service after any celebration.
 */
@Component({
  selector: 'app-achievements-revoked-dialog',
  templateUrl: './achievements-revoked-dialog.component.html',
  styleUrls: ['./achievements-revoked-dialog.component.scss'],
})
export class AchievementsRevokedDialogComponent {
  readonly revoked: RevokedBadgeModel[];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: RevokedBadgeModel[],
    private dialogRef: MatDialogRef<AchievementsRevokedDialogComponent>,
    private router: Router
  ) {
    this.revoked = data || [];
  }

  get single(): RevokedBadgeModel {
    return this.revoked.length === 1 ? this.revoked[0] : null;
  }

  seeAll(): void {
    this.dialogRef.close(true);
    this.router.navigate(['/profile/achievements']);
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
